import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, Teleport as _Teleport, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  ref: "panelEl",
  class: "nge-ver",
  role: "status",
  "aria-live": "polite"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "nge-ver-corner nge-ver-corner--tl",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "nge-ver-corner nge-ver-corner--br",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */)
const _hoisted_4 = { class: "nge-ver-label" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  class: "nge-ver-pip",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "nge-ver-label-text" }, "New version ready", -1 /* HOISTED */)
const _hoisted_7 = ["aria-expanded", "title"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "nge-ver-text" }, "Pyr was updated while you were here. Reload to get the newest fixes. Your edits are already saved.", -1 /* HOISTED */)
const _hoisted_9 = {
  key: 0,
  id: "nge-ver-changes",
  class: "nge-ver-changes",
  tabindex: "0",
  "aria-label": "What changed"
}
const _hoisted_10 = {
  key: 0,
  class: "nge-ver-changes-note"
}
const _hoisted_11 = {
  key: 1,
  class: "nge-ver-changes-note"
}
const _hoisted_12 = { class: "nge-ver-changes-head" }
const _hoisted_13 = {
  key: 0,
  class: "nge-ver-changes-note"
}
const _hoisted_14 = { class: "nge-ver-change-title" }
const _hoisted_15 = { class: "nge-ver-change-day" }
const _hoisted_16 = { class: "nge-ver-actions" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", {
  class: "nge-ver-pip",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      ($setup.version.newer && !$setup.folded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _hoisted_6,
              _createElementVNode("button", {
                type: "button",
                class: "nge-ver-info",
                "aria-expanded": $setup.showChanges ? 'true' : 'false',
                "aria-controls": "nge-ver-changes",
                title: $setup.showChanges ? 'Hide what changed' : 'See what changed',
                "aria-label": "What changed",
                onClick: $setup.toggleChanges
              }, "i", 8 /* PROPS */, _hoisted_7)
            ]),
            _hoisted_8,
            ($setup.showChanges)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (!$setup.changes)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, "Reading what changed."))
                    : (!$setup.changes.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, "No notes were written for this update. It is likely a small fix."))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createElementVNode("div", _hoisted_12, _toDisplayString($setup.changesAreNew ? 'What changed' : 'Earlier changes'), 1 /* TEXT */),
                          (!$setup.changesAreNew)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, "This update has no new notes: it is a fix behind the scenes. These came before it."))
                            : _createCommentVNode("v-if", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.changes, (c, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: i,
                              class: "nge-ver-change"
                            }, [
                              _createElementVNode("div", _hoisted_14, [
                                _createTextVNode(_toDisplayString(c.title), 1 /* TEXT */),
                                _createElementVNode("span", _hoisted_15, _toDisplayString($setup.dayOf(c.at)), 1 /* TEXT */)
                              ]),
                              _createElementVNode("ul", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(c.items, (item, j) => {
                                  return (_openBlock(), _createElementBlock("li", { key: j }, _toDisplayString(item), 1 /* TEXT */))
                                }), 128 /* KEYED_FRAGMENT */))
                              ])
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ], 64 /* STABLE_FRAGMENT */))
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("button", {
                type: "button",
                class: "nge-ver-btn nge-ver-go",
                disabled: $setup.reloading,
                onClick: $setup.reload
              }, _toDisplayString($setup.reloading ? 'Reloading' : 'Reload now'), 9 /* TEXT, PROPS */, _hoisted_17),
              _createElementVNode("button", {
                type: "button",
                class: "nge-ver-btn",
                onClick: _cache[0] || (_cache[0] = $event => ($setup.folded = true))
              }, "Later")
            ])
          ], 512 /* NEED_PATCH */))
        : _createCommentVNode("v-if", true)
    ])),
    ($setup.version.newer && $setup.folded && !$setup.dismissed)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: $setup.inBar ? '.nge-toolbar-icons' : 'body'
        }, [
          _createCommentVNode(" One pill (Ames 2026-11-02: the x sat outside the box): Reload, then x. "),
          _createElementVNode("span", {
            class: _normalizeClass(["nge-ver-chip", { 'nge-ver-chip--bar': $setup.inBar, 'nge-ver-chip--busy': $setup.reloading }])
          }, [
            _createElementVNode("button", {
              type: "button",
              class: "nge-ver-chip-go",
              disabled: $setup.reloading,
              title: "A newer version of Pyr is out. Click to reload and get it.",
              onClick: $setup.reload
            }, [
              _hoisted_19,
              _createTextVNode(_toDisplayString($setup.reloading ? 'Reloading' : 'Update ready'), 1 /* TEXT */)
            ], 8 /* PROPS */, _hoisted_18),
            _createElementVNode("button", {
              type: "button",
              class: "nge-ver-chip-x",
              title: "Hide this. The update comes with your next reload.",
              "aria-label": "Hide the update reminder",
              onClick: $setup.dismiss
            }, "×")
          ], 2 /* CLASS */)
        ], 8 /* PROPS */, ["to"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}